import { createMigrate, type PersistedState } from 'redux-persist'

type LegacySelectFilterType = { label: string; operator: string; selection: string; slug: string }

const isLegacySelectFilter = (f: unknown): f is LegacySelectFilterType =>
  typeof f === 'object' && f !== null && 'selection' in f

const migrations = {
  1: (state: PersistedState) => state,
  2: (state: PersistedState) => {
    const s = state as (PersistedState & { cardFilters?: unknown[] }) | undefined
    if (!s?.cardFilters) return state
    return {
      ...s,
      cardFilters: s.cardFilters.map((f) =>
        isLegacySelectFilter(f)
          ? { operator: f.operator, selections: [{ label: f.label, value: f.selection }], slug: f.slug }
          : f,
      ),
    }
  },
}

export const GALLERY_PERSIST_VERSION = 2

export const galleryMigrate = createMigrate(migrations, { debug: false })
